import { Component, Input, HostListener, OnChanges } from '@angular/core';
import { Business } from '../../../services/business.service';
import { environment } from '../../../../environments/environment';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnChanges {
  @Input() hasMultipleBranches = false;
  @Input() menuBranches: any[] = [];
  @Input() business: Business | null = null;
  @Input() menuUrl: string = '';  // ← receive from parent instead of computing here

  isSticky = false;
  isCollapsed = true;
  showMenuDropdown = false;

  selectedLanguage: string = 'en';
  languageOptions = [
    { label: 'English', value: 'en' },
    { label: 'العربية', value: 'ar' }
  ];

  constructor(public languageService: LanguageService) {
    const stored = localStorage.getItem('appLanguage');
    this.selectedLanguage = (stored === 'ar' ? 'ar' : 'en');
    this.languageService.setLanguage(this.selectedLanguage as 'en' | 'ar');
    this.languageService.language$.subscribe(lang => {
      this.selectedLanguage = lang;
    });
  }

  ngOnChanges() {
    console.log('[navbar] menuBranches received:', this.menuBranches);
    console.log('[navbar] hasMultipleBranches:', this.hasMultipleBranches);
    console.log('[navbar] menuUrl:', this.menuUrl);
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.menu-multi-wrapper')) {
      this.showMenuDropdown = false;
    }
  }

  toggleMenuDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.showMenuDropdown = !this.showMenuDropdown;
  }

  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      this.isCollapsed = true;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isSticky = scrollTop > 100;
  }

  getLogoUrl(logoPath?: string): string {
    return logoPath ? `${environment.baseUrl}${logoPath}` : 'assets/images/logo.png';
  }

  onLanguageChange(lang: string) {
    this.selectedLanguage = lang;
    this.languageService.setLanguage(lang as 'en' | 'ar');
    localStorage.setItem('appLanguage', lang);
  }
}